import React from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { status } from "../../datasource/schema/purchased_services.json";
import {
    withStyles,
    Typography,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Table,
} from "@material-ui/core";

import { formatMoney } from "../../lib/helperFuncs.jsx";
import services from "../../datasource/schema/services.json";

const calcModes = services?.calculation_mode;

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const INCLUDED_MESSAGES = {
    included: "Включено в общую стоимость",
    notIncluded: "Не включено в общую стоимость",
};

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography>
            <Typography variant="h5">{children}</Typography>
            {onClose && (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            )}
        </MuiDialogTitle>
    );
});

const ServicesDialog = (props) => {
    const outerServices = [...props.services];

    const translateCalculation_mode = (raw) => {
        return calcModes.values[raw];
    };

    const services = outerServices.map((service) => (
        <TableRow key={`service_id: ${service.id}`}>
            <TableCell>{service.name}</TableCell>
            <TableCell>{formatMoney(service.price)}</TableCell>
            <TableCell>{service.pivot.comment}</TableCell>
            <TableCell>{status.values[service?.pivot.status]}</TableCell>
        </TableRow>
    ));

    const servicesTable =
        outerServices?.length === 0 ? (
            <Typography style={{ minWidth: 310, padding: "1rem" }}>
                Услуги отсутствуют
            </Typography>
        ) : (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Название</TableCell>
                        <TableCell>Стоимость</TableCell>
                        <TableCell>Пожелание</TableCell>
                        <TableCell>Статус</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{services}</TableBody>
            </Table>
        );

    return (
        <Dialog
            maxWidth="lg"
            open={props.openServicesDialog}
            onClose={props.setOpenServicesDialog.bind(null, false)}
            scroll={"body"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <DialogTitle
                id="customized-dialog-title"
                onClose={props.setOpenServicesDialog.bind(null, false)}
            >
                Список услуг
            </DialogTitle>
            {servicesTable}
        </Dialog>
    );
};

ServicesDialog.propTypes = {
    services: PropTypes.array,
    openServicesDialog: PropTypes.bool,
    setOpenServicesDialog: PropTypes.func,
    fields: PropTypes.object,
};

export default ServicesDialog;
